// eslint-disable-next-line import/prefer-default-export
export const queryIds = {
  qr: {
    GET_BUILDING_INFO: 'getBuildingInfo',
    GET_CASE_CLASSIFICATIONS: 'getCaseClassifications',
  },
};
